export default __webpack_public_path__ + "static/media/refrisander-gray.03130336.webp";